import { useState } from "react";
import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";
import logobigok from "../../assets/SurveyDepartment_Brunei.png";
import chairman from "../../assets/default-bg.jpeg";
import TitleAndDate from "../../components/TitleAndDate";

const charimanflag = "https://upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Brunei.svg";

function Chairmanship() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Navbar />
      {/* <main className="max-w-5xl mx-auto px-6 py-10">
       */}
      <main className="container mx-auto px-20">
        {/* Title + Date */}
        <TitleAndDate title="CHAIRMANSHIP UNGEGN ASIA SOUTH-EAST DIVISION (ASE DIVISION)" />

        {/* Chairman Section */}
        <section className="mt-12 flex flex-col md:flex-row items-start md:items-center gap-10">
          <img
            src={chairman}
            alt="Chairman"
            className="w-56 h-auto rounded-lg shadow-lg"
            onClick={() => setIsOpen(true)}
          />
          <div className="space-y-3">
            <p className="text-gray-600 mb-5">Chairman (2022-2026)</p>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Nor Zetty Akhtar Haji Abdul Hamid
            </h2>
            <p className="text-gray-600 mb-2">Nationality</p>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Brunei Darussalam
            </h3>

            <img
              src={charimanflag}
              alt="Chairman Flag"
              className="h-12 w-auto mt-3 rounded shadow-lg"
            />

            {/* Button untuk Pop-up */}
            {/* <div className="mt-8">
              <button
                onClick={() => setIsOpen(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Open Welcome Message
              </button>
            </div> */}
          </div>
        </section>

        {/* Agency Section */}
        <section className="mt-12 border-t border-gray-200 pt-8 flex flex-col md:flex-row items-start gap-10 mb-20">
          <img
            src={logobigok}
            alt="BIG Logo"
            className="w-56 h-auto rounded-lg shadow-md"
          />
          <div className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              SURVEY DEPARTMENT MINISTRY OF DEVELOPMENT BANDAR SERI BEGAWAN BB3510 BRUNEI DARUSSALAM
            </h2>
            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              http://www.mod.gov.bn/survey
            </a>
            <br />
            <br />
          </div>
        </section>
      </main>
      <Footer />

      {/* Modal Pop-up */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg p-6 relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
            >
              ✕
            </button>
            <p className="text-gray-700 text-justify">
              <span class="font-bold">Welcome</span> to the{" "}
              <span class="font-bold text-blue-600">
                UNGEGN Asia South-East Division
              </span>{" "}
              website. <br /> <br />
              Since the division was first established in 2011, we have been
              developing our community sincerely and take great interest in
              fulfilling our resolutions. The collaborative platform was
              developed to support regional data sharing in updating and
              maintaining the regional map and gazetteer, as well as displaying
              generic terms from member countries. The website reflected all the
              hard work and dedication in the development of the division as
              well as in the larger interests towards the issues of geographical
              names.
              <br /> <br />
              Finally, thank you for visiting our website.
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default Chairmanship;
